module.exports = __webpack_public_path__ + "img/home_slide_01.2a2b4d76.png";